import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import { LinearProgress, Stack, Typography } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'
import type { FileProgress } from '../../shared/run-upload'

export interface FileRowProps {
  name: string
  roleLabel?: string
  problem?: string
  progress?: FileProgress
}

export default function FileRow({
  name,
  roleLabel,
  problem,
  progress,
}: FileRowProps) {
  const { formatMessage } = useIntl()
  const percent =
    progress && progress.total > 0
      ? Math.round((progress.loaded / progress.total) * 100)
      : 0

  return (
    <Stack spacing={0.5} data-testid={`avatar-file-${name}`}>
      <Stack direction="row" spacing={1} alignItems="center">
        {problem ? (
          <ErrorOutlineIcon fontSize="small" color="error" aria-hidden={true} />
        ) : (
          <CheckCircleOutlineIcon
            fontSize="small"
            color="success"
            aria-hidden={true}
          />
        )}
        <Typography variant="body2" translate="no" sx={{ minWidth: 0 }} noWrap={true}>
          {name}
        </Typography>
        {roleLabel && !problem && (
          <Typography variant="caption" color="text.secondary">
            {roleLabel}
          </Typography>
        )}
        {progress && progress.status === 'done' && (
          <Typography variant="caption" color="success.main">
            {formatMessage({ id: 'avatarStudio.upload.done' })}
          </Typography>
        )}
        {progress && progress.status === 'waiting' && (
          <Typography variant="caption" color="text.secondary">
            {formatMessage({ id: 'avatarStudio.upload.waiting' })}
          </Typography>
        )}
      </Stack>

      {problem && (
        <Typography variant="caption" color="error.main" sx={{ pl: 3.5 }}>
          {problem}
        </Typography>
      )}

      {progress && progress.status === 'uploading' && (
        <LinearProgress
          variant="determinate"
          value={percent}
          aria-label={formatMessage(
            { id: 'avatarStudio.upload.progressAria' },
            { name, percent },
          )}
        />
      )}
    </Stack>
  )
}
